import styled from "styled-components";
import {
	TABLET_BP,
	MOBILE_L_BP,
	FONT_WT_LIGHT,
	FONT_WT_MEDIUM,
	COLOR_TEXT_PRIMARY_B2C,
	COLOR_LIGHT_GREEN,
	COLOR_DARK_GREY,
	COLOR_WHITE,
	COLOR_BOX_SHADOW,
	FONT_WT_REGULAR,
	COLOR_DARK_GREEN_BUTTON,
	COLOR_NOBEL_GREY,
	COLOR_TEXT_HIGHLIGHT,
	COLOR_ERROR_RED,
	COLOR_BORDER_INPUT,
} from "@website-builder/utilities-index";

export const SelectWrapper = styled.div`
	.dropdown {
		box-sizing: border-box;
		border: solid 1px #c5c5cf;
		border-radius: 3px;
		font-size: 16px;
		font-weight: ${FONT_WT_LIGHT};
		line-height: normal;
		text-align: left;
		color: ${COLOR_TEXT_PRIMARY_B2C};
		padding: 16px 12px 13px 12px;
		user-select: none;
		background: white;
		position: relative;
		margin-bottom: 20px;
	}

	.dropdown-text {
		position: relative;
		cursor: pointer;
		line-height: normal;
		font-weight: ${FONT_WT_LIGHT};
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		background: white;
		&::after {
			content: " ";
			position: absolute;
			top: 4px;
			right: 5px;
			transform: rotate(90deg);
			transition: all 100ms ease;
			border-top: 6px solid transparent;
			border-bottom: 6px solid transparent;
			border-left: 6px solid ${COLOR_NOBEL_GREY};
		}
		&.list-open::after {
			transform: rotate(270deg);
		}
		&.no-list::after {
			display: none;
		}
	}
	.dropdown-selected {
		color: ${COLOR_TEXT_PRIMARY_B2C};
	}
	.dropdown-not-selected {
		color: ${COLOR_NOBEL_GREY};
	}

	.list-container {
		box-sizing: border-box;
		width: 100%;
		box-shadow: 0 8px 10px 0 rgba(0, 0, 0, 0.1);
		border-radius: 0px 0px 3px 3px;
		font-size: 16px;
		font-weight: ${FONT_WT_LIGHT};
		line-height: normal;
		text-align: left;
		color: ${COLOR_TEXT_PRIMARY_B2C};
		padding: 0px 12px 0px 12px;
		left: 0px;
		top: 47px;
		user-select: none;
		position: absolute;
		background: white;
		z-index: 1000;
	}

	.dropdown-list {
		list-style-type: none;
		padding: 0;
		margin: 0;
		&.scrollable-list {
			overflow-y: auto;
			scrollbar-color: ${COLOR_TEXT_HIGHLIGHT};
		}
	}

	/* width */
	.scrollable-list::-webkit-scrollbar {
		width: 6px;
	}

	/* Track */
	.scrollable-list::-webkit-scrollbar-track,
	ms-scrollbar-track-color {
		background: ${COLOR_BORDER_INPUT};
		border-radius: 3px;
		margin-top: 11px;
		margin-bottom: 11px;
	}

	/* Handle */
	.scrollable-list::-webkit-scrollbar-thumb {
		background: ${COLOR_TEXT_HIGHLIGHT};
		border-radius: 3px;
	}

	/* Handle on hover */
	.scrollable-list::-webkit-scrollbar-thumb:hover {
		background: ${COLOR_TEXT_HIGHLIGHT};
	}

	.dropdown-list li {
		cursor: pointer;
		font-size: 16px;
		font-weight: ${FONT_WT_LIGHT};
		line-height: 35px;
		color: ${COLOR_TEXT_PRIMARY_B2C};
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		&:hover {
			color: ${COLOR_TEXT_HIGHLIGHT};
		}
	}

	.form-control-error-icon {
		color: ${COLOR_ERROR_RED};
		position: absolute;
		right: 16px;
		top: 50px;
		font-size: 18px;
		display: block;
		top: 15px;
		&.fa {
			font-size: 16px;
		}
		font-family: FontAwesome !important;
	}

	label.select-error {
		background-color: ${COLOR_ERROR_RED};
		color: white;
		float: right;
		padding: 2px 10px;
		border-radius: 4px;
		position: relative;
		margin-bottom: 9px;
		font-weight: ${FONT_WT_LIGHT};
		font-size: 12px;
		z-index: 100;

		&::after {
			content: "";
			position: absolute;
			right: 20px;
			top: 100%;
			width: 0;
			height: 0;
			border-left: 8px solid transparent;
			border-right: 8px solid transparent;
			border-top: 8px solid ${COLOR_ERROR_RED};
			clear: both;
		}
	}

	label.select-error-pos {
		position: absolute;
		right: -5px;
		bottom: 43px;
	}
`;
